import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {UsersClientActionsPage} from './components/UsersClientActionsPage';
import {LayoutSplashScreen, ContentRoute} from '../../../_metronic/layout';

export default function UsersClientActionsPageContainer() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/logs-users-client-actions" component={UsersClientActionsPage}/>
      </Switch>
    </Suspense>
  );
}
